import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { InfoAction, Sheet } from '@pkg/components';
import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { type ExpireOption } from '@pkg/hooks';
import { formatFloat, formatUsd } from '@pkg/utils';

import { CollectionChainType } from '@app/client';

import { AssetCard, type AssetCardProps, getNumberDirection, getNumberSign } from '../AssetCard';
import { ExpireSelector, type ExpireSelectorProps } from '../ExpireSelector';

import { mock } from './mock';

import { MainInterior, Section, SectionHeader, TitleMedium } from './AssetOfferSheet.style';

// TODO: Determine API for this "feature component".
export interface AssetOfferSheetProps {
    expiration?: ExpireOption;
    onClose: () => void;
    onExpirationChange: ExpireSelectorProps['onSelect'];
}

export function AssetOfferSheet({ expiration = 'week', onClose, onExpirationChange }: AssetOfferSheetProps) {
    const [translate] = useTranslation('marketplace');

    const floorPriceSuffixData = [
        getNumberSign(mock.priceChange24h),
        formatUsd(Math.abs(mock.priceChange24h), true),
        ` (${formatFloat(mock.percentChange24h, 1)}%)`,
    ];

    const [tempItemPrice, setTempItemPrice] = useState<string | number>();

    const handlePriceChange: AssetCardProps['onPriceChange'] = (value = '') => {
        const formatted = value.toString().replace(/[^\d.-]/g, '');
        setTempItemPrice(formatted);
    };

    async function handleSubmit() {
        // await newOffer();
        // eslint-disable-next-line no-console
        console.log('TODO: handleSubmit');
        onClose();
    }

    return (
        <Sheet gapless backdrop onClose={onClose}>
            <Sheet.Header largeTitle title={translate('asset-offer-sheet-title')} onClose={onClose} />

            <Sheet.Main>
                <Sheet.Layout>
                    <Sheet.Layout.Columns stretch>
                        <Sheet.Layout.Columns.Primary padded scrollable>
                            <MainInterior>
                                <Section>
                                    <AssetCard
                                        asset={{
                                            name: mock.assetName,
                                            collection: {
                                                name: mock.collectionName,
                                                contractAddress: mock.contractAddress,
                                                chain: CollectionChainType.Ethereum,
                                            },
                                            imageUrl: mock.thumbnail,
                                            tokenId: mock.tokenId,
                                        }}
                                        localPrice={tempItemPrice}
                                        // nativePrice={}
                                        onPriceChange={handlePriceChange}
                                    >
                                        <AssetCard.StatsList
                                            items={[
                                                {
                                                    label: translate('common-chip-price'),
                                                    value: formatUsd(mock.floorPriceUsd, true),
                                                    suffix: floorPriceSuffixData.join(''),
                                                    suffixType: getNumberDirection(mock.percentChange24h),
                                                },
                                                {
                                                    label: translate('common-chip-best-offer'),
                                                    value: formatUsd(mock.bestOfferUsd, true),
                                                },
                                            ]}
                                        />
                                    </AssetCard>
                                </Section>

                                <Section>
                                    <SectionHeader>
                                        <TitleMedium>{translate('asset-offer-sheet-section-title-period')}</TitleMedium>

                                        <InfoAction
                                            message="TODO: Also requires tooltip!"
                                            aria-label={translate('common-info-action-a11y')}
                                        />
                                    </SectionHeader>

                                    <ExpireSelector selected={expiration} onSelect={onExpirationChange} />
                                </Section>
                            </MainInterior>
                        </Sheet.Layout.Columns.Primary>
                    </Sheet.Layout.Columns>

                    <Sheet.Layout.Footer>
                        <Button
                            fluid
                            size="large"
                            variant="solid"
                            aria-label={translate('asset-offer-sheet-cta-a11y')}
                            onClick={handleSubmit}
                        >
                            {translate('asset-offer-sheet-cta')}
                        </Button>
                    </Sheet.Layout.Footer>
                </Sheet.Layout>
            </Sheet.Main>
        </Sheet>
    );
}
